<!-- MFITTで予約済みのチケットをキャンセルする場合 -->
<template>
  <ItemDialog ref="confirmCancelReservation" imageType="alert">
    <template v-slot:content-area>
      <h2>予約の取り消し</h2>
      <p class="text-center">予約を取り消します。よろしいですか?</p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="予約取り消し" actionType="btn-primary" @clicked="cancelReservation()" />
      <ItemButton label="閉じる" actionType="btn-cancel" @clicked="closeDialog()" />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogConfirmCancelReservation",
  setup(_, context) {
    const confirmCancelReservation = ref(null);

    const cancelReservation = () => {
      context.emit("cancelReservation");
    };

    const openDialog = () => {
      confirmCancelReservation.value.open();
    };

    const closeDialog = () => {
      confirmCancelReservation.value.close();
    };

    return {
      confirmCancelReservation,
      cancelReservation,
      openDialog,
      closeDialog,
    };
  },
};
</script>
